// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4402":"886b76ed","4752":"b68654f0","8855":"7d6696a4"}[chunkId] + ".chunk.css";
};